<div class="modal-header">
  <h4 class="modal-title">Create Cognito User</h4>
</div>
<div class="modal-body" ngbAutofocus>
  <div class="m-y-10">Set a password for the user below. Make sure to ask them to change it after they login.</div>
  <div class="form-group">
    <span class="sm">Enter password...</span>
    <input class="form-control" [(ngModel)]="password" />
    <br />
  </div>
  <span class="btn btn-primary" (click)="submit()" [class.disabled]="loading">{{ loading ? "Creating..." : "Create Cognito User" }}</span>
</div>
